
// 设置分类
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRaw,
  toRefs,
  watch,
} from "vue"
import type {UnwrapRef} from "vue"
import ApiLogistics from "@/request/apis/api_logistics"
import {message} from "ant-design-vue/es"
import UploadComponent from "@/components/UploadComponent.vue"
import {IEditDriver} from "@/models/logistics_member"

interface IState {
  loading: boolean
  editItem?: IEditDriver
}

export default defineComponent({
  props: ["editItem", "reset"],
  name: "DriverSet",
  components: {UploadComponent},
  setup(props) {
    const state: IState = reactive({
      loading: false,
      list: [],
    })

    const formRef = ref()
    const formState: UnwrapRef<IEditDriver> = reactive({...props.editItem})

    const rules = {
      name: [
        {
          required: true,
          message: "请输入分类名称",
          trigger: ["change", "blur"],
        },
      ],
      phone: [
        {
          required: true,
          message: "请输入电话",
          trigger: ["change", "blur"],
        },
      ],
      head_img: [{required: true, message: '请上传头像', trigger: ['change', 'blur']}],
    }

    const onSubmit = () => {
      formRef.value
          .validate()
          .then(() => {
            onEdit()
          })
          .catch((error: any) => {
            console.log("error", error)
          })
    }
    const resetForm = () => {
      formRef.value.resetFields()
    }

    // 编辑
    const onEdit = async () => {
      state.loading = true
      const res = await ApiLogistics.editDriver({
        ...toRaw(formState),
      })
      state.loading = false
      if (res) {
        message.destroy()
        if (res.error_code === 0) {
          message.success("编辑成功")
          if (props.reset) {
            props.reset()
          }
          return
        }
        message.error(res.msg)
      }
    }

    const onImageChange = (url: string) => {
      formState.head_img = url
    }

    return {
      ...toRefs(state),
      formRef,
      labelCol: {span: 6},
      wrapperCol: {span: 18},
      other: "",
      formState,
      rules,
      onSubmit,
      resetForm,
      onEdit,
      onImageChange,
    }
  },
})
